// ---------------------------------------------------------------------------
// Re-export do primitivo canônico, PROMOVIDO para components/StatusBadge em
// 2026-09-11 (FC7 §H.4 — extrair, não copiar: o EmployeeNameSearch, que é
// compartilhado, passou a ser o segundo consumidor). Mantido aqui para não
// gerar churn nas ~6 telas do Recrutamento que já importam deste caminho.
// Código novo importa direto de components/StatusBadge.
// ---------------------------------------------------------------------------
import StatusBadge from '../../../../components/StatusBadge';

export default StatusBadge;
